<template>
    <div class="diverse-content-wrapper">
        <div class="w-100">
          <template v-for="(option) in step.options">
            <div class="form-element form-element-bg">
            <fieldset>
              <legend>
                <ContentHeadline :subtitle="option.subtitle" :id="createHeadlineId(option.title)">{{option.title}}</ContentHeadline>
              </legend>
                <div v-if="option.type === 'datepicker'">
                    <DateRangeSelects
                        :name="option.name"
                        :singleDatePicker="!option.range"
                        :timePicker="option.time"
                        :step="step"
                        :isDiverse="true"
                        :class="{ error: step.models[option.name].error }"
                        :checkinLabelId="option.range ? null : createHeadlineId(option.title)"
                        :checkin-label="extractLabels(option.datePickerText)[0]"
                        :checkout-label="extractLabels(option.datePickerText)[1]"
                    />
                </div>
                <div v-else-if="option.type === 'people'">
                    <PeopleConfigurator v-for="(item, index) in step.items" :key="`key-${index}`" :item="item"
                                        :index="index"
                                        :isDiverse="true"
                                        @changed="resetNextDisabledHint"
                                        :step="step"
                                        ref="people"
                                        :mandatory="option.mandatory"
                                        :moreCountLabels="option.moreCounts"
                    />
                </div>
                <div v-else-if="option.type === 'cart_summary'">
                  <CartSummary :step="step" :title="option.title" ref="cart"/>
                </div>
                <div v-else-if="option.type === 'radio'">
                    <div class="form-group" :class="{ 'is-invalid': step.models[option.name].error }">
                        <div class="pl-4" v-for="(entry, index) in option.entries">
                            <input @change="validateOption(option.name)" class="form-check-input"
                                   v-model="step.models[option.name].value" :name="option.name" :id="option.name+index"
                                   type="radio"
                                   :value="entry">
                            <label :for="option.name+index">{{entry}}</label>
                        </div>
                        <div class="invalid-feedback">
                          {{ $t('mod.diverse.errors.select') }}
                        </div>
                    </div>
                </div>
                <div v-else-if="option.type === 'checkbox'">
                    <div class="pl-4" v-for="(entry, index) in option.entries">
                        <input @change="validateOption(option.name)" class="form-check-input"
                               :class="{ 'is-invalid': step.models[option.name].error }"
                               v-model="step.models[option.name].value" :name="option.name" :id="option.name+index"
                               type="checkbox"
                               :value="entry">
                        <label :for="option.name+index">{{entry}}</label>
                        <div class="invalid-feedback">
                          {{ $t('mod.diverse.errors.required') }}
                        </div>
                    </div>
                </div>
                <div v-else-if="option.type === 'select'">
                    <select v-model="step.models[option.name].value"
                            :aria-labelledby="createHeadlineId(option.title)"
                            class="form-control col-11 col-md-8 fw-bold form-select"
                            @change="validateOption(option.name)"
                            :class="{ 'is-invalid': step.models[option.name].error }"
                    >
                        <option value="">{{option.prompt || "-- Bitte wählen Sie --"}}</option>
                        <template v-for="(entry) in option.entries">
                          <option :value="entry.key ? entry.key : entry">{{ entry.name ? entry.name : entry }}</option>
                        </template>
                    </select>
                </div>
                <div v-else-if="option.type === 'time'">
                    <input type="time"
                           :aria-labelledby="createHeadlineId(option.title)"
                           :step="option.step || 900"
                           v-model="step.models[option.name].value"
                           class="form-control col-11 col-md-8 col-lg-4 fw-bold"
                           @change="validateOption(option.name)"
                           :class="{ 'is-invalid': step.models[option.name].error }"
                    />
                </div>
                <div v-else-if="option.type === 'textarea'">
                    <textarea id="diverse-message" rows="10"
                              :aria-labelledby="createHeadlineId(option.title)"
                              v-model="step.models[option.name].value"
                              class="form-control"
                              :placeholder="option.placeholder"
                              :class="{ 'is-invalid': step.models[option.name].error }"
                              @blur="validateOption(option.name)"
                    ></textarea>
                </div>
                <div v-else-if="option.type === 'text' || option.type === 'url'">
                    <datalist v-if="option.entries" :id="createId(option.title)+'_list'">
                        <option v-for="label in option.entries">{{label}}</option>
                    </datalist>
                    <input :type="option.type"
                           :id="createId(option.title)"
                           :aria-labelledby="createHeadlineId(option.title)"
                           :list="option.entries ? createId(option.title)+'_list' : null"
                           v-model="step.models[option.name].value"
                           class="form-control"
                           :placeholder="option.placeholder"
                           :class="{ 'is-invalid': step.models[option.name].error }"
                           @blur="validateOption(option.name)"
                    >
                </div>
                <div v-else-if="option.type === 'number'">
                    <input type="number"
                           :id="createId(option.title)"
                           :aria-labelledby="createHeadlineId(option.title)"
                           v-model="step.models[option.name].value"
                           class="form-control text-right"
                           :placeholder="option.placeholder"
                           :class="{ 'is-invalid': step.models[option.name].error }"
                           @blur="validateOption(option.name)"
                           :min="option.min"
                           :max="option.max"
                           :step="option.step"
                    >
                </div>
                <div v-else>unsupported type: {{option.type}}</div>
            </fieldset>
            </div>
          </template>
        </div>
        <div class="form-group row justify-content-end mt-5 mb-4">
            <div class="col-12 col-md-4">
                <div class="alert alert-warning" role="alert" v-show="showNextDisabledHint">
                  {{ $t('form.hint.nextDisabled') }}
                </div>
                <button type="button" @click="clickNext" class="btn btn-dark btn-block next">
                  {{ $t('form.action.next') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import mixinCreateId from "../mixins/createId";
    import CartSummary from './partials/CartSummary';
    import PeopleConfigurator from './partials/PeopleConfigurator';
    import QueryParam from "../../forms6/QueryParam";
    import ContentHeadline from "./partials/ContentHeadline.vue";
    import DateRangeSelects from "./partials/DateRangeSelects.vue";

    export default {
        mixins: [mixinCreateId],
        props: ['step'],
        components: {
            DateRangeSelects,
          CartSummary,
          ContentHeadline,
          PeopleConfigurator,
        },
        data() {
            return {
                showNextDisabledHint: false,
            };
        },
        created() {
            if (!this.step.checkin) {
                this.step.options.forEach(option => {
                    if (option.type === 'datepicker') {
                        this.step.tryToPresetDates(this.$store, option.name, !option.range);
                    }
                });
            }
            this.step.wasValidated = false;
            for(let i = 0; i < this.step.options.length; i++) {
                const matchingOption = this.step.options[i]
                if(!matchingOption.name) {
                    continue
                }
                const preselectParamName = matchingOption.preselectParamName || matchingOption.name
                const preselectOption = QueryParam.getQueryVariable(preselectParamName)
                if (preselectOption && preselectOption.length > 0) {
                    const re = new RegExp(preselectOption, 'gi');
                    const matchingEntry = matchingOption.entries.find(function (value) {
                        if (value.key) {
                            return value.key === preselectOption;
                        }
                        return value.match(re);
                    });
                    if (matchingEntry) {
                        this.step.models[matchingOption.name].value = matchingEntry.key ? matchingEntry.key : matchingEntry
                    }
                }
            }

        },
        methods: {
          extractLabels(datePickerText) {
              const components = datePickerText?.split(/\s*-\s*/) || []
            return components
          },
            resetNextDisabledHint() {
                this.showNextDisabledHint = false;
            },
            validateOption(key) {
                this.showNextDisabledHint = false;
                const model = this.step.models[key]
                let error = false;
                if (typeof model.mandatory !== 'undefined' && model.mandatory) {
                    if (model.value.length === 0) {
                        error = true;
                    }
                }
                if (model.type === 'people') {
                    error = false;
                }
                this.$forceUpdate();
                model.error = error;
                return !error;
            },
            handleUserData(key) {
              if (key === 'cart_summary') {
                const cartComponent = Array.isArray(this.$refs.cart) ?
                  this.$refs.cart[0] : this.$refs.cart; // no clue why $refs.cart is an array - ref should be unique
                cartComponent.handleUserData();
              }
                this.showNextDisabledHint = false;
                let option = this.step.models[key];
                let text = option.value;
                let name = key;
                if (option.type === 'checkbox') {
                    text = option.value.join(', ');
                    name = key + '[]';
                }
                this.$store.commit('updateUserInput', {
                    name: name,
                    module: this.step.type,
                    input: option.value
                });
                if (option.value.length > 0 && typeof option.title !== 'undefined') {
                    this.step.addToSummary({label: option.summary_title || option.title, text: text});
                }
            },
            getModelByType(type) {
                let returnModel = false;
                Object.keys(this.step.models).forEach((key) => {
                    const model = this.step.models[key];
                    if (model.type === type && model.value === "") {
                        returnModel = model;
                    }
                });
                return returnModel;
            },
            validatePeopleConfigurator(validations) {
                if (!this.$refs.people) {
                    return;
                }
                for (let i = 0; i < this.$refs.people.length; i++) {
                    const peopleValid = this.$refs.people[i].validate();
                    if (peopleValid) {
                        let model = this.getModelByType('people');
                        const item = this.step.items[i];
                        let itemIdx = 0;
                        const modelAdult = {
                            name: 'blocks[' + model.index + '][items][' + itemIdx + '][' + item.fieldName + ']',
                            value: item.adults
                        };
                        const modelChildren = {
                            name: 'blocks[' + model.index + '][items][' + itemIdx + '][children]',
                            value: item.children.length
                        };
                        const modelChildrenAges = {
                            name: 'blocks[' + model.index + '][items][' + itemIdx + '][child_ages]',
                            value: item.childAge
                        };
                        this.step.setModel(modelAdult);
                        if (item.renderChildren) {
                            this.step.setModel(modelChildren);
                            if (item.renderChildAge) {
                                this.step.setModel(modelChildrenAges);
                            }
                        }

                        item.counts.forEach(cnt => {
                            itemIdx++;
                            this.step.setModel({
                                name: 'blocks[' + model.index + '][items][' + itemIdx + '][label]',
                                value: cnt.label,
                            });
                            this.step.setModel({
                                name: 'blocks[' + model.index + '][items][' + itemIdx + '][count]',
                                value: cnt.count,
                            });
                        });
                    }
                    validations.push(peopleValid);
                    //add people to summary -> change in case there will be more than one item!
                    this.step.addToSummary({label: 'Personen', text: this.step.items[0].descriptionDiverse()});
                }
            },
            validate() {
                let validations = [];

                this.validatePeopleConfigurator(validations);

                Object.keys(this.step.models).forEach((key) => {
                    const validated = this.validateOption(key);
                    if (validated) {
                        this.handleUserData(key)
                    }
                    validations.push(validated);
                });

                return validations.every(v => v);
            },

            clickNext(e) {
                this.step.clearSummary();
                if (this.validate()) {
                    this.$store.commit('setNextStep');
                } else {
                    this.showNextDisabledHint = true;
                }
            }
        }
    }
</script>

<style scoped>
/* .form-control sets w-100
  if field is very long user looses connection between
    label and value for number (text align right)
    date and and calendar at the end (firefox/chrome desktop)
*/
input[type="number"],
input[type="date"] {
  max-width: 12em;
}
</style>